<template>
    <div class="migrol-form__input-wrapper" :style="computedStyle">
        <label class="migrol-form__input-label" v-if="label">{{label}}</label>
        <div class="migrol-form__readonly-text">{{value}}</div>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            label: {
            },
            flex: {
                type: String,
                default: '1',
                required: false
            },
            value: {
                default: '',
                required: true
            }
        },
        computed: {
            computedStyle() {
                return this.flex != '1' ? { flex: this.flex } : null;
            }
        }
    }
</script>